// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8cc0e317","788":"0cd487ca"}[chunkId] + ".chunk.js";
};